'use strict';

var isXHRAvailable = global.XMLHttpRequest && 'withCredentials' in new global.XMLHttpRequest();

function getRequestObject() {
  return isXHRAvailable ? new XMLHttpRequest() : new XDomainRequest();
}

module.exports = {
  isAvailable: isXHRAvailable,
  getRequestObject: getRequestObject
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/braintree-web/client/request/xhr.js
// module id = 274
// module chunks = 0